module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addAnnotationDialog.addAnnotationTitle":"Add Annotation","addAnnotationDialog.addAnnotationSubtitle":"Add a new annotation for this entity","addAnnotationDialog.successfulAdd":"Annotation successfully added."}}')
  delete Component.options._Ctor
}
